/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import React from 'react';
import { Form, FormInstance } from 'antd';

interface Step3ContentProps {
  form: FormInstance;
}

const labelClass =
  'block text-[15px] sm:text-[16px] font-semibold text-[#111827] mb-2';

const inputBase =
  'w-full h-[52px] sm:h-[56px] rounded-xl border bg-white px-4 sm:px-5 ' +
  'text-[16px] sm:text-[17px] text-[#111827] placeholder:text-[#9CA3AF] ' +
  'outline-none transition';

const focusGreen =
  'focus:border-[#16A34A] focus:ring-2 focus:ring-[#16A34A]/20';
const borderDefault = 'border-[#D1D5DB]';

const Required = () => <span className="ml-1 text-[#DC2626]">*</span>;

export default function Step3Content({ form }: Step3ContentProps) {
  return (
    <div className="space-y-5 sm:space-y-6">


      <Form.Item
        name="email"
        className="mb-0"
        rules={[
          { required: true, message: 'Email is required' },
          { type: 'email', message: 'Enter a valid email' },
        ]}
      >
        <div>
          <label className={labelClass}>
            Email
            <Required />
          </label>
          <input
            className={`${inputBase} ${borderDefault} ${focusGreen}`}
            placeholder="e.g. john@example.com"
            autoComplete="email"
            inputMode="email"
          />
        </div>
      </Form.Item>

      <Form.Item
        name="phone"
        className="mb-0"
        rules={[{ required: true, message: 'Phone Number is required' }]}
      >
        <div>
          <label className={labelClass}>
            Phone Number
            <Required />
          </label>
          <input
            className={`${inputBase} ${borderDefault} ${focusGreen}`}
            placeholder="e.g. 0712345678"
            autoComplete="tel"
            inputMode="tel"
          />
        </div>
      </Form.Item>
    </div>
  );
}
